export type PecadoName =
  | 'gula'
  | 'envidia'
  | 'ira'
  | 'lujuria'
  | 'pereza'
  | 'avaricia'
  | 'soberbia'

export type Pecado = {
  id: number
  name: PecadoName
  pre_description: string
  post_description: string
  description: string
}

export const pecados_base: Array<Pecado> = [
  {
    id: 1,
    name: 'gula',
    description: 'La gula es el apetito desmedido por comer y beber.',
    pre_description: 'La',
    post_description: 'es el apetito desmedido por comer y beber.',
  },
  {
    id: 2,
    name: 'envidia',
    description:
      'La envidia es el sentimiento de tristeza o enojo que experimenta la persona que no tiene o desearía tener para sí sola algo que otra posee.',
    pre_description: 'La',
    post_description:
      'es el sentimiento de tristeza o enojo que experimenta la persona que no tiene o desearía tener para sí sola algo que otra posee.',
  },
  {
    id: 3,
    name: 'ira',
    description: 'La ira es el sentimiento no controlado de odio y enfado.',
    pre_description: 'La',
    post_description: 'es el sentimiento no controlado de odio y enfado.',
  },
  {
    id: 4,
    name: 'lujuria',
    description: 'La lujuria es deseo sexual descontrolado o exacerbado.',
    pre_description: 'La',
    post_description: 'es deseo sexual descontrolado o exacerbado.',
  },
  {
    id: 5,
    name: 'pereza',
    description: 'La pereza es el tedio o descuido en realizar actividades.',
    pre_description: 'La',
    post_description: 'es el tedio o descuido en realizar actividades.',
  },
  {
    id: 6,
    name: 'avaricia',
    description:
      'La avaricia es el deseo de obtener bienes, riquezas o poder con la sola intención de atesorarlos para sí mismo/a.',
    pre_description: 'La',
    post_description:
      'es el deseo de obtener bienes, riquezas o poder con la sola intención de atesorarlos para sí mismo/a.',
  },
  {
    id: 7,
    name: 'soberbia',
    description:
      'La soberbia es el sentimiento de superioridad frente a otras personas que provoca un trato distante o despreciativo hacia ellas.',
    pre_description: 'La',
    post_description:
      'es el sentimiento de superioridad frente a otras personas que provoca un trato distante o despreciativo hacia ellas.',
  },
]
